/*
* Contact Map
*/

export const MAP_STYLE = [
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#000000"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#000000"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "saturation": "0"
            },
            {
                "color": "#afafaf"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "saturation": "0"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#7c7c7c"
            },
            {
                "lightness": "0"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": "0"
            },
            {
                "weight": "1.81"
            },
            {
                "visibility": "simplified"
            },
            {
                "gamma": "0.00"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#515151"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#505050"
            },
            {
                "lightness": 17
            }
        ]
    }
]


/* global google */

$.fn.ContactMap = function() {
  let self = this
  self.map = undefined
  self.marker = undefined

  return function() {
    setTimeout(function() {
      self.map = new google.maps.Map(self.get(0), {
        styles: MAP_STYLE,
        disableDefaultUI: true,
        zoom: 14,
        scrollwheel: true,
        center: {
          lat: 45.5805667,
          lng: -73.7478087,
        },
      })

      self.marker = new google.maps.Marker({
        position: {
          lat: 45.5805667,
          lng: -73.7478087,
        },
        icon: {
          //url: '/img/elements/map-marker2.svg',
          //size: new google.maps.Size(50, 50),
          //scaledSize: new google.maps.Size(50, 50),
          //origin: new google.maps.Point(0, 0),
          //anchor: new google.maps.Point(9, 45),
        },
        map: self.map,
        url: "https://www.google.com/maps/place/Macucina/@45.5805667,-73.7478087,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc929fe3bb18a07:0xfc1f0011929cacb2!8m2!3d45.580563!4d-73.74562",
      })

      google.maps.event.addListener(self.marker, 'click', function() {
        window.open(this.url, '_blank')
      })
    }, $.mlmi.mobile.isMobile ? 800 : 0)

    return self
  }()
}
